// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-form {
  min-height: 100vh;
  width: 100%;
}

.form-content {
  width: 100%;
  height: 100%;
} `, "",{"version":3,"sources":["webpack://./src/components/ClientForm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".client-form {\n  min-height: 100vh;\n  width: 100%;\n}\n\n.form-content {\n  width: 100%;\n  height: 100%;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
